import type { ReactNode } from "react"
import { Stack, Tooltip } from "@mui/material"
import HelpOutlineRoundedIcon from "@mui/icons-material/HelpOutlineRounded"

const PlotHelpTooltip = ({ content }: { content: ReactNode[] }) => {
  return (
    <Tooltip
      title={<Stack gap={2}>{content}</Stack>}
      enterTouchDelay={0}
      placement="bottom-start"
      arrow
    >
      <HelpOutlineRoundedIcon
        sx={{
          fontSize: 16,
          color: (theme) => theme.palette.neutral[500],
          cursor: "help",
          verticalAlign: "middle",
        }}
      />
    </Tooltip>
  )
}

export default PlotHelpTooltip
